import { useState } from 'react';
import { alpha } from '@mui/material/styles';
import { Typography, Stack, Tooltip, IconButton } from '@mui/material';
import MenuPopover from '../../../components/MenuPopover';
import { IconButtonAnimate } from '../../../components/animate';
import useLocales from 'src/hooks/useLocales';
import IconifyIcon from 'src/components/icons/IconifyIcon';
import { IconifyIconEnum } from 'src/@types/icon';

const CONTACT_EMAIL = 'partner@tixa.hu';

export default function ContactsPopover() {
  const { translate } = useLocales();

  const [open, setOpen] = useState<HTMLElement | null>(null);

  const [copiedEmail, setCopiedEmail] = useState(false);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleCopyEmailToClipboard = () => {
    navigator.clipboard.writeText(CONTACT_EMAIL);
    setCopiedEmail(true);
    setTimeout(() => setCopiedEmail(false), 2000);
  };

  return (
    <>
      <IconButtonAnimate
        color={open ? 'primary' : 'default'}
        onClick={handleOpen}
        sx={{
          width: 40,
          height: 40,
          ...(open && {
            bgcolor: (theme) =>
              alpha(theme.palette.primary.main, theme.palette.action.focusOpacity),
          }),
        }}
      >
        <IconifyIcon icon={IconifyIconEnum.People} width={24} height={24} />
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          mt: 1.5,
          ml: 0.75,
          width: 260,
        }}
      >
        <Typography variant="h6" sx={{ p: 1.5 }}>
          {translate('contactPopover.contact')}
        </Typography>

        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ px: 1.5, py: 1.5 }}>
          <IconifyIcon
            icon={IconifyIconEnum.Handshake}
            sx={{ width: 32, height: 32, color: 'primary.main', flexShrink: 0 }}
          />

          <Typography variant="subtitle1" sx={{ flexGrow: 1, color: 'text.secondary' }}>
            {CONTACT_EMAIL}
          </Typography>

          <Tooltip
            enterTouchDelay={0}
            arrow
            placement="top"
            title={translate(copiedEmail ? 'contactPopover.copied' : 'contactPopover.copy')}
          >
            <IconButton size="small" onClick={handleCopyEmailToClipboard}>
              <IconifyIcon icon={IconifyIconEnum.Copy} sx={{ width: 20, height: 20 }} />
            </IconButton>
          </Tooltip>
        </Stack>
      </MenuPopover>
    </>
  );
}
